// src/icon-system/runtime/OzellikIkonu.tsx — KAYITLI ÖZELLİĞİN İKONU
//
// ══════════════════════════════════════════════════════════════════════════
// Tek işi var: KAYITTAN (`ozellikKaydi.ts`) aile + varyant + erişilebilir ad
// kararını türetip mevcut köprüye devretmek. Çizim, kontur, boyut, tembel
// yükleme, a11y çerçevesi ve HAREKET kararlarının hiçbiri burada DEĞİLDİR.
//
// Aldığı tek tekrar, çağrı yerlerine dağılmış şu ifadedir:
//     varyant={activeTab === "home" ? "selected" : "outline"}
// `BottomNav.tsx`te DÖRT ayrı satırda yazılıydı; aile adı, erişilebilir
// etiket ve geçişlilik artık tek yerde kayıtlı.
//
// ══════════════════════════════════════════════════════════════════════════
// 🔴 ÖLÇÜM HATAM VE DÜZELTMESİ (2026-09-19) — "HAREKET YOK" YANLIŞTI
// ══════════════════════════════════════════════════════════════════════════
// Bu dosyanın ilk hâli, ikon durum-değişimi hareketinin depoda BULUNMADIĞI
// ölçümüne dayanarak KENDİ hareket katmanını (ayrı bir CSS dosyası, 27
// parça seçicisi, kendi `@keyframes`i) getiriyordu. O ölçüm YANLIŞTI ve
// sebebi kanonun bilinen kusuru: kapsamı DAR tuttum. `src/icon-system/`
// altında `prefers-reduced-motion|animation` aradım, 1 isabet buldum (bir
// levha üreticisinin gömülü stili) → "yok" dedim. Oysa kural motorun KENDİ
// dizininde değil, uygulamanın merkezî stil sayfasındaydı:
//
//     src/index.css:470-486
//       [data-ikon][data-varyant="selected"] [data-parca="fill"],
//       [data-ikon][data-varyant="selected"] [fill="currentColor"]
//         { animation: ikon-dolgu var(--dur-3,200ms) var(--ease-out) both; }
//       + [data-ikon] { transition: color var(--dur-1) var(--ease-out); }
//       + @media (prefers-reduced-motion: reduce) → ikisi de `none`
//
// Yani hareket ZATEN VARDI, token'a bağlıydı, hareket-azalt tercihini
// uyguluyordu ve `data-parca` üzerinden çalışıyordu.
//
// ⚠ VE İKİNCİ SİSTEM YALNIZ FAZLALIK OLMAYACAKTI — ONAYLI DAVRANIŞI
//   DEĞİŞTİRECEKTİ. Manifest-güdümlü seçicilerim `navigation.search`
//   (`lens handle`) ve `navigation.discovery` (`planet spark`) ailelerini de
//   hareketlendirirdi. `src/index.css`teki yorum bu ailelerin hareketsiz
//   kalmasının bir KARAR olduğunu yazıyor: *"`esit` ailelerde (search/create/
//   discovery) dolgu YOKTUR → eşleşme de yoktur (doğru: o ailelerde ayrı bir
//   selected görünümü yok)"* — ve `KULLANIM_SOZLESMESI §5` bunu owner sözüyle
//   kayda geçiriyor: *"outline = selected olabilir; aktiflik nav üzerinden
//   gösterilir."* Kendi katmanım o kararı sessizce bozardı.
//
// 🧭 Bu yüzden ikinci katman SİLİNDİ. Hareket mevcut merkezî kuraldan gelir;
//    bu bileşen ona yalnız `data-varyant`ı doğru zamanda vererek KATILIR.
//    Aşağıdaki `data-ozellik` yalnız ölçüm/seçici kolaylığıdır — hiçbir
//    hareket kuralı ona bağlı DEĞİLDİR.
//
// 📌 MEVCUT KATMANDA ÖLÇÜLEN İKİ SINIR (onarımı BU TURUN İŞİ DEĞİL; kayıt):
//   1. Kural ilk MOUNT'ta da çalar: sayfa seçili bir sekmeyle açıldığında o
//      ikon bir kez "belirir". Ürün kararı olabilir; ölçüldü, not edildi.
//   2. Hedefleme SEZGİSEL: parça adı `fill` ya da özniteliği
//      `fill="currentColor"`. Manifestin `hareketParcalari` alanı (77 ailede
//      dolu) çalışma zamanında HİÇ okunmuyor — ölçüldü:
//      `git grep hareketParcalari -- src/**` yalnız testlere, tooling'e ve
//      yorumlara çarpıyor. Bugün zararsız, çünkü `selected` varyantı olmayan
//      ailelerin hareket parçaları zaten hiç tetiklenmiyor (ölçüm: 42 dolu
//      ailenin 13'ünde `hareketParcalari ⊄ selected katmanları`).
import React from "react";
import { IkonKoprusu } from "./IkonKoprusu";
import type { IkonKoprusuProps } from "./IkonKoprusu";
import type { OzellikDefteri, FeatureId } from "./ozellikKaydi";
import { URUN_OZELLIKLERI } from "./ozellikKaydi";
import { ikonAdayOnizlemeAcikMi } from "./ikonBayragi";

export type OzellikIkonuProps = Omit<IkonKoprusuProps, "aile" | "varyant" | "title"> & {
  /** Seçili mi. Yalnız `gecisli: true` kayıtlarda varyantı etkiler. */
  secili?: boolean;
  /**
   * İkon, özelliğin ADINI TAŞIYOR mu?
   *  · `false` (varsayılan) → ikon DEKORATİF (`aria-hidden`); adı komşu
   *    düğme/metin taşır. `BottomNav` tam olarak budur: düğmede zaten
   *    `aria-label` var (BottomNav.tsx:156 vd.).
   *  · `true` → `IconFrame` `role="img"` + `aria-label` + `<title>` çizer.
   * Açıkça sorulur: ikisini birden yapmak ekran okuyucuda ÇİFT AD üretir.
   */
  adTasiyici?: boolean;
} & (
  /** Varsayılan ürün defterinde yanlış kimlik derleme hatasıdır. */
  | { ozellik: FeatureId; defter?: undefined }
  /** Test/önizleme özel defteri açıkça verir; bilinmeyen kimlik runtime'da reddedilir. */
  | { ozellik: string; defter: OzellikDefteri }
);

export function OzellikIkonu({
  ozellik,
  secili = false,
  adTasiyici = false,
  defter = URUN_OZELLIKLERI,
  ...koprüProps
}: OzellikIkonuProps): React.ReactElement {
  const kayit = defter.coz(ozellik);
  const varyant = kayit.gecisli && secili ? "selected" : "outline";
  // ── ADAY ÖNİZLEME (2026-09-21) ────────────────────────────────────────
  // Kaydında `adayAilesi` olan özellik, YALNIZ `?ikonAday=on` iken ÜRETİLEN
  // adayı çizer. Bayraksız yolda bugünkü aile birebir çizilir — owner'ın
  // "insan çizimi REPOST yerinde kalsın" emri burada uygulanır. `data-aday`
  // ölçüm içindir: kare alırken hangi kolun çizildiği DOM'dan okunabilsin
  // (kanon: "kareye baktım" bir teşhis değildir — kol DOM'dan doğrulanır).
  // ⚠ Bu bayrak yalnız AİLEYİ SEÇER, yayın kapısını AŞMAZ (owner 2026-09-26):
  // aday aile taslaktır → köprüdeki `yayinKapisi` onu `onayli` kapsamda `eski`ye
  // düşürür. Aday görmek için `?ikon=on&ikonKapsam=tam&ikonAday=on`.
  const adayKolu = Boolean(kayit.adayAilesi) && ikonAdayOnizlemeAcikMi();
  const aile = adayKolu && kayit.adayAilesi ? kayit.adayAilesi : kayit.aile;
  return (
    <IkonKoprusu
      aile={aile}
      varyant={varyant}
      title={adTasiyici ? kayit.etiket : undefined}
      data-ozellik={kayit.id}
      data-aday={adayKolu ? "1" : undefined}
      {...koprüProps}
    />
  );
}
